import { Modal } from 'antd';
import React from 'react';
import UploadUniqueInput from '../../../components/model/business/forms/UploadUniqueInput';
import { DrawerPanelTitle, modalPanelStyles } from '../Drawers/DrawerPanelTitle';

interface Props {
  visible: boolean,
  handleVisible: React.Dispatch<React.SetStateAction<boolean>>,
  locationId: string,
  titleText: string,
  category: string,
  textBtn: string,
}

const UpdtPicsModal = ({
  visible,
  handleVisible,
  locationId,
  titleText,
  category,
  textBtn
}: Props): JSX.Element => {

  return (
    <>
      <Modal
        open={visible}
        footer={null}
        width={450}
        onCancel={() => handleVisible(false)}
        {...modalPanelStyles}
        title={<DrawerPanelTitle title={titleText} />}
      >
        <UploadUniqueInput
          selectedKeys={[locationId]}
          onFinish={() => handleVisible(false)}
          category={category}
          textBtn={textBtn}
        />
      </Modal>
    </>
  );
};

export default UpdtPicsModal
